// Mirrors the output of trpc.purchasing.scanDocument (apps/web/src/api/trpc/routers/purchasing.ts).
import type { ImportedReceipt } from "../Purchases/types";

export type ScanKind = "receipt" | "invoice" | "order";

export type ScanResult = {
  document_key: string | null;
  document: {
    document_type: "delivery_note" | "invoice" | "order_confirmation" | "other";
    supplier_name: string | null;
    supplier_vat_id: string | null;
    document_number: string | null;
    issue_date: string | null;
    due_date: string | null;
    delivery_date: string | null;
    currency: string | null;
    net_total: number | null;
    vat_total: number | null;
    total: number | null;
    lines_match_total: boolean | null;
    vat_rates: (number | null)[];
  };
  match: Omit<ImportedReceipt, "lines"> & {
    lines: (ImportedReceipt["lines"][number] & { line_total: number })[];
  };
};

/** The kind a scanned document most likely is. */
export const suggestedKind = (r: ScanResult, fallback: ScanKind): ScanKind =>
  r.document.document_type === "invoice"
    ? "invoice"
    : r.document.document_type === "delivery_note"
      ? "receipt"
      : r.document.document_type === "order_confirmation"
        ? "order"
        : fallback;
